export interface TopicCategory {
  id: string;
  name: string;
  icon: string;
  count: number;
  blurb: string;
}

export interface Topic {
  id: number;
  title: string;
  categoryId: string;
  categoryName: string;
  summary: string;
  cover: string;
  heat: number;
  comments: number;
  views: number;
  updatedAt: string;
  status: string;
  tags: string[];
  editor: string;
  rankChange: number;
}

export interface DiscussComment {
  id: number;
  topicId: number;
  user: string;
  role: string;
  content: string;
  time: string;
  likes: number;
  featured: boolean;
}

export interface StanceItem {
  party: string;
  content: string;
}

export interface TimelineItem {
  time: string;
  text: string;
}

export interface TopicDetail {
  topicId: number;
  background: string;
  focusPoints: string[];
  timeline: TimelineItem[];
  stances: StanceItem[];
  editorNote: string;
}

export const topicCategories: TopicCategory[] = [
  { id: 'variety', name: '综艺现场', icon: 'ri-tv-2-line', count: 42, blurb: '录制花絮、剪辑争议与临场反应' },
  { id: 'drama', name: '影视剧集', icon: 'ri-clapperboard-line', count: 63, blurb: '选角、剧本与片场传闻' },
  { id: 'idol', name: '选秀偶像', icon: 'ri-music-2-line', count: 38, blurb: '团体合约、行程与粉丝动态' },
  { id: 'life', name: '生活圈热议', icon: 'ri-contrast-drop-line', count: 27, blurb: '演出、活动与日常争议' },
  { id: 'brand', name: '品牌与商业', icon: 'ri-shopping-bag-3-line', count: 19, blurb: '代言、带货与合作变动' },
  { id: 'sports', name: '体育赛场', icon: 'ri-football-line', count: 15, blurb: '判罚争议与赛事说明' },
];

export const topics: Topic[] = [
  {
    id: 1,
    title: '某综艺录制现场片段流出，是剪辑争议还是真实冲突？',
    categoryId: 'variety',
    categoryName: '综艺现场',
    summary:
      '一段未播出的录制现场画面在社交平台流传，节目组尚未正式回应。网友根据片段中的现场收音与座位顺序逐帧分析，讨论焦点从「谁对谁错」转向「剪辑是否改变了事实」。',
    cover:
      'https://readdy.ai/api/search-image?query=moody%20empty%20variety%20show%20stage%20with%20colorful%20spotlights%20and%20blurred%20silhouettes%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20tones%2C%20clean%20composition&width=800&height=600&seq=gt-grid-01&orientation=landscape',
    heat: 9821,
    comments: 1284,
    views: 326000,
    updatedAt: '今天 14:20',
    status: '讨论中',
    tags: ['剪辑争议', '现场收音', '逐帧分析'],
    editor: '观察员 · 小满',
    rankChange: 3,
  },
  {
    id: 2,
    title: '热播剧女主换角传闻发酵，剧组深夜发布长文说明',
    categoryId: 'drama',
    categoryName: '影视剧集',
    summary:
      '换角消息在开机前后反复出现，剧组于凌晨发布说明，提到「角色调整源于剧本结构变化」，但未回应具体演员的档期问题，讨论区对这份说明的可信度出现两种判断。',
    cover:
      'https://readdy.ai/api/search-image?query=film%20set%20with%20clapperboard%20and%20soft%20bokeh%20lights%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20tones%2C%20clean%20composition&width=800&height=600&seq=gt-grid-02&orientation=landscape',
    heat: 8760,
    comments: 942,
    views: 214000,
    updatedAt: '今天 11:05',
    status: '已有回应',
    tags: ['换角传闻', '剧本调整', '官方说明'],
    editor: '观察员 · 阿川',
    rankChange: 1,
  },
  {
    id: 3,
    title: '出道男团成员退团传闻升温，后援会统一发布声明',
    categoryId: 'idol',
    categoryName: '选秀偶像',
    summary:
      '关于成员是否退团的讨论持续升温，多个粉丝后援会发布统一声明，希望公司给出明确答复。截至目前，经纪公司只更新了团体行程表，未就传闻单独发文。',
    cover:
      'https://readdy.ai/api/search-image?query=blurred%20glowing%20light%20sticks%20at%20a%20pop%20concert%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20and%20red%20tones%2C%20abstract&width=800&height=600&seq=gt-grid-03&orientation=landscape',
    heat: 7640,
    comments: 1560,
    views: 188000,
    updatedAt: '今天 09:48',
    status: '等待回应',
    tags: ['退团传闻', '粉丝后援会', '团体合约'],
    editor: '观察员 · 柚子',
    rankChange: -1,
  },
  {
    id: 4,
    title: '一段后台花絮录音被公开，双方对时间点的说法不一致',
    categoryId: 'variety',
    categoryName: '综艺现场',
    summary:
      '有账号公开了一段后台花絮录音，录音中的人物与时间点成为争议核心。两个版本的时间线相差约四十分钟，讨论区正在核对当日公开行程与现场照片的拍摄时间。',
    cover:
      'https://readdy.ai/api/search-image?query=audio%20mixing%20console%20in%20a%20dark%20recording%20studio%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20accent%20light%2C%20clean%20composition&width=800&height=600&seq=gt-grid-04&orientation=landscape',
    heat: 6980,
    comments: 806,
    views: 152000,
    updatedAt: '昨天 22:31',
    status: '讨论中',
    tags: ['花絮录音', '时间线', '双方回应'],
    editor: '观察员 · 小满',
    rankChange: 2,
  },
  {
    id: 5,
    title: '品牌代言物料临时下架，官方仅回应「档期调整」',
    categoryId: 'brand',
    categoryName: '品牌与商业',
    summary:
      '某品牌在多个平台临时下架了代言相关物料，官方客服回应为「档期调整」。由于同期并没有公开的负面事件，讨论区对下架原因给出多种猜测，暂无可靠信源。',
    cover:
      'https://readdy.ai/api/search-image?query=product%20podium%20with%20single%20spotlight%20in%20a%20minimal%20showroom%2C%20editorial%20photography%2C%20warm%20beige%20and%20red%20tones%2C%20clean%20composition&width=800&height=600&seq=gt-grid-05&orientation=landscape',
    heat: 5920,
    comments: 431,
    views: 97000,
    updatedAt: '昨天 19:12',
    status: '等待回应',
    tags: ['代言物料', '临时下架', '商业合作'],
    editor: '观察员 · 阿川',
    rankChange: 0,
  },
  {
    id: 6,
    title: '老牌演员「片场耍大牌」说法再起，多位工作人员接连发声',
    categoryId: 'drama',
    categoryName: '影视剧集',
    summary:
      '关于片场工作态度的说法每隔一段时间就会被提起。这一次有多位自称剧组工作人员陆续发文，内容彼此有重叠也有冲突，讨论区提醒先分辨信源再做判断。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20film%20set%20with%20a%20director%20chair%20under%20warm%20lighting%2C%20cinematic%20editorial%20photography%2C%20amber%20tones%2C%20clean%20composition&width=800&height=600&seq=gt-grid-06&orientation=landscape',
    heat: 5530,
    comments: 688,
    views: 121000,
    updatedAt: '昨天 16:40',
    status: '讨论中',
    tags: ['片场传闻', '工作人员发声', '拍摄进度'],
    editor: '观察员 · 林间',
    rankChange: -2,
  },
  {
    id: 7,
    title: '音乐节临时调整阵容，主办方与歌手指责互相甩锅',
    categoryId: 'life',
    categoryName: '生活圈热议',
    summary:
      '临开场前的阵容调整引发连锁反应，主办方称是「不可抗力」，部分的演出方则指向合同与结算问题。退票方案已经公布，但关于责任归属的讨论仍在继续。',
    cover:
      'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20dusk%20with%20warm%20string%20lights%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20red%20tones&width=800&height=600&seq=gt-grid-07&orientation=landscape',
    heat: 4980,
    comments: 512,
    views: 88000,
    updatedAt: '昨天 12:03',
    status: '已有回应',
    tags: ['音乐节', '阵容调整', '退票方案'],
    editor: '观察员 · 柚子',
    rankChange: 4,
  },
  {
    id: 8,
    title: '短剧爆火后被指抄袭，原作者发文列出完整时间线',
    categoryId: 'drama',
    categoryName: '影视剧集',
    summary:
      '一部播放量很高的短剧被指与更早发布的图文作品高度相似。原作者整理了从发布到改编的时间线，制作方回应「属于常见桥段」，双方尚未进入法律程序。',
    cover:
      'https://readdy.ai/api/search-image?query=stack%20of%20film%20scripts%20and%20an%20open%20notebook%20on%20a%20wooden%20desk%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20clean%20composition&width=800&height=600&seq=gt-grid-08&orientation=landscape',
    heat: 4610,
    comments: 397,
    views: 76000,
    updatedAt: '09-08 21:15',
    status: '讨论中',
    tags: ['短剧', '抄袭争议', '时间线对比'],
    editor: '观察员 · 林间',
    rankChange: 1,
  },
  {
    id: 9,
    title: '赛场判罚争议升级，赛事官方公布多角度回放画面',
    categoryId: 'sports',
    categoryName: '体育赛场',
    summary:
      '一次关键判罚在赛后持续引发讨论。赛事官方公布了多个机位的回放与裁判报告，说明判罚依据，部分球迷认可解释，也有球迷认为规则本身需要细化。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20sports%20stadium%20field%20under%20floodlights%20at%20night%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20tones&width=800&height=600&seq=gt-grid-09&orientation=landscape',
    heat: 4120,
    comments: 356,
    views: 69000,
    updatedAt: '09-08 18:22',
    status: '事件已澄清',
    tags: ['判罚争议', '多角度回放', '官方说明'],
    editor: '观察员 · 阿川',
    rankChange: -3,
  },
  {
    id: 10,
    title: '综艺嘉宾临场救场片段爆红，网友却质疑是提前写好的剧本',
    categoryId: 'variety',
    categoryName: '综艺现场',
    summary:
      '一段临场救场的片段被反复传播，播放量迅速攀升。导演在采访中表示「没有剧本」，但网友从镜头切换与灯光调度上提出了不同看法，讨论集中在综艺的真实性边界。',
    cover:
      'https://readdy.ai/api/search-image?query=television%20studio%20panel%20desk%20with%20microphones%20and%20warm%20lights%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=gt-grid-10&orientation=landscape',
    heat: 3870,
    comments: 602,
    views: 71000,
    updatedAt: '09-08 15:47',
    status: '已有回应',
    tags: ['临场救场', '剧本质疑', '导演回应'],
    editor: '观察员 · 小满',
    rankChange: 2,
  },
  {
    id: 11,
    title: '女团成员疑似恋情曝光，经纪公司简短回应「私事不回应」',
    categoryId: 'idol',
    categoryName: '选秀偶像',
    summary:
      '几组生活照片在网络流传后，相关话题迅速升温。经纪公司简短回应「艺人私事不做回应」，讨论区随后转向「公众人物的隐私边界在哪里」这一更普遍的问题。',
    cover:
      'https://readdy.ai/api/search-image?query=concert%20crowd%20glow%20with%20warm%20stage%20light%20and%20bokeh%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20red%20tones%2C%20abstract&width=800&height=600&seq=gt-grid-11&orientation=landscape',
    heat: 3560,
    comments: 890,
    views: 64000,
    updatedAt: '09-07 20:10',
    status: '已有回应',
    tags: ['恋情传闻', '经纪公司', '隐私边界'],
    editor: '观察员 · 柚子',
    rankChange: -1,
  },
  {
    id: 12,
    title: '直播带货「翻车」风波，平台公布退款进度与抽检结果',
    categoryId: 'brand',
    categoryName: '品牌与商业',
    summary:
      '关于某场直播货品质量的投诉集中出现后，平台公布了退款进度与第三方抽检结果。抽检显示部分批次需要召回，平台同时调整了该场次的售后通道。',
    cover:
      'https://readdy.ai/api/search-image?query=live%20streaming%20setup%20with%20ring%20light%20and%20camera%20in%20a%20cozy%20room%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20clean%20composition&width=800&height=600&seq=gt-grid-12&orientation=landscape',
    heat: 3210,
    comments: 274,
    views: 58000,
    updatedAt: '09-07 13:35',
    status: '事件已澄清',
    tags: ['直播带货', '抽检结果', '退款进度'],
    editor: '观察员 · 阿川',
    rankChange: -2,
  },
];

export const discussions: DiscussComment[] = [
  // topic 1
  { id: 101, topicId: 1, user: '隔壁桌的小柯', role: '网友', content: '把现场收音单独拉出来听了一遍，前两句话之间确实有明显的时间断点，建议先别急着站队，等完整未剪版本。', time: '12分钟前', likes: 428, featured: true },
  { id: 102, topicId: 1, user: '剪辑师老周', role: '认证网友 · 后期从业', content: '从镜头切换的节奏看，这段更像是粗剪素材外流，而不是成片。粗剪和成片的叙事差别可以很大，用粗剪判断态度风险很高。', time: '26分钟前', likes: 913, featured: true },
  { id: 103, topicId: 1, user: '只看证据', role: '网友', content: '讨论焦点应该放在「素材如何外流」上，而不是急着给现场的人定性。外流本身是另一个更值得追问的问题。', time: '48分钟前', likes: 265, featured: false },
  { id: 104, topicId: 1, user: '夜航船', role: '网友', content: '座位顺序那块我反复看了，和节目里播出的走位能对上，但中间少了大概两秒画面，可能是转场也可能是别的原因。', time: '1小时前', likes: 187, featured: false },
  // topic 2
  { id: 201, topicId: 2, user: '剧本观察', role: '认证网友 · 编剧', content: '「剧本结构变化」这个说法在行业里确实存在，但通常会有配套的官宣节奏。只发文字说明不给时间节点，信息量确实偏少。', time: '32分钟前', likes: 356, featured: true },
  { id: 202, topicId: 2, user: '追剧不放糖', role: '网友', content: '我更关心已经拍完的部分怎么办。换角如果是真的，前期物料、海报、预告都得重做，这成本不小，所以传闻也不能全信。', time: '1小时前', likes: 214, featured: false },
  { id: 203, topicId: 2, user: '片场盒饭侠', role: '网友', content: '凌晨发长文这个时间点挺微妙的，既想降温又不想白天被追问。建议等下周有没有正式的发布会。', time: '2小时前', likes: 133, featured: false },
  // topic 3
  { id: 301, topicId: 3, user: '灯牌举高一点', role: '网友', content: '后援会的声明写得挺克制，核心诉求就是一句话：给个明确答复。比起猜测退不退团，先要一个官方口径才是最实际的。', time: '20分钟前', likes: 512, featured: true },
  { id: 302, topicId: 3, user: '合约在读生', role: '认证网友 · 娱乐法务', content: '团体合约的处理一般涉及多方协商，即使内部已有结论，对外披露也会有节奏。这不代表一定有问题，但确实需要耐心。', time: '55分钟前', likes: 402, featured: true },
  { id: 303, topicId: 3, user: '路人甲在吃瓜', role: '网友', content: '行程表更新但人不出现，这种「用行动回应」的方式其实最难解读，容易让各种猜测都找到空间。', time: '2小时前', likes: 176, featured: false },
  // topic 4
  { id: 401, topicId: 4, user: '时间线控', role: '网友', content: '两个版本差四十分钟，这个差值刚好能装下一段彩排。建议把当天公开的彩排路透时间也拉进来一起对。', time: '34分钟前', likes: 298, featured: true },
  { id: 402, topicId: 4, user: '录音棚外的猫', role: '认证网友 · 音频从业', content: '这段录音的环境噪声比较连续，中间没有明显剪辑痕迹，但也不能排除是分段录制的。设备信息比内容本身更关键。', time: '1小时前', likes: 341, featured: false },
  { id: 403, topicId: 4, user: '冷静吃瓜', role: '网友', content: '把「谁说的」和「说了什么」拆开看会清楚很多。现在两边其实都在争夺同一件事的解释权。', time: '3小时前', likes: 122, featured: false },
  // topic 5
  { id: 501, topicId: 5, user: '柜台前的顾客', role: '网友', content: '客服口径统一成「档期调整」通常意味着内部有沟通，但未必和网传的事有关。没有信源的情况下还是先观望。', time: '1小时前', likes: 165, featured: true },
  { id: 502, topicId: 5, user: '商业观察笔记', role: '认证网友 · 品牌营销', content: '物料下架在营销里是很常见的操作，排期、平台规则、物料合规都可能触发。把它直接等同于负面事件，证据链是断的。', time: '2小时前', likes: 209, featured: false },
  { id: 503, topicId: 5, user: '今天也在逛商场', role: '网友', content: '线下门店的海报好像还在，只有线上撤了，这个细节值得记录一下。', time: '4小时前', likes: 88, featured: false },
  // topic 6
  { id: 601, topicId: 6, user: '剧组打杂日记', role: '网友', content: '这类说法每年都会出现一次，真正的信息量在于有没有具体的拍摄日期和场次。没有细节的描述很难当作依据。', time: '2小时前', likes: 233, featured: true },
  { id: 602, topicId: 6, user: '看戏不站队', role: '网友', content: '几个人发的说法互相对不上，恰恰说明不能只挑对自己有利的版本看。建议列表对比。', time: '3小时前', likes: 154, featured: false },
  { id: 603, topicId: 6, user: '老剧重刷中', role: '网友', content: '作品好不好和片场传闻应该分开评价。把演员的作品和私德绑在一起讨论，很容易失焦。', time: '5小时前', likes: 276, featured: false },
  // topic 7
  { id: 701, topicId: 7, user: '买票进场的我', role: '网友', content: '退票通道已经开了，这点值得肯定。但责任划分如果一直模糊，下次谁还敢提前买票。', time: '1小时前', likes: 198, featured: true },
  { id: 702, topicId: 7, user: '舞台下的风', role: '认证网友 · 演出策划', content: '临时调整阵容常见原因是审批与结算，两者都会在临开场前才暴露。「不可抗力」这个说法需要更具体的说明才有说服力。', time: '3小时前', likes: 187, featured: false },
  { id: 703, topicId: 7, user: '帐篷里的歌单', role: '网友', content: '希望后续能把已购票观众的补偿方案写清楚，比争论谁先发声明重要得多。', time: '5小时前', likes: 121, featured: false },
  // topic 8
  { id: 801, topicId: 8, user: '图文搬运鉴定', role: '网友', content: '时间线整理得比较清楚，但「相似」和「抄袭」之间还有距离，关键要看具体表达是否构成实质性相似。', time: '2小时前', likes: 245, featured: true },
  { id: 802, topicId: 8, user: '追短剧的人', role: '网友', content: '短剧节奏快、桥段密度高，容易撞梗。这既是行业问题，也不能成为不查证的理由。', time: '4小时前', likes: 133, featured: false },
  { id: 803, topicId: 8, user: '版权小站', role: '认证网友 · 内容合规', content: '如果真要维权，取证方式是关键：发布时间的公证、平台后台记录都比截图更有证明力。', time: '6小时前', likes: 176, featured: false },
  // topic 9
  { id: 901, topicId: 9, user: '看台第七排', role: '网友', content: '多角度回放放出来后，争议点其实从「判得对不对」变成了「规则要不要改」。这是好事，讨论终于落到具体条文上。', time: '3小时前', likes: 287, featured: true },
  { id: 902, topicId: 9, user: '规则手册翻烂了', role: '认证网友 · 裁判员', content: '按现行条文这次的判罚站得住脚，但条文本身在「明显机会」的界定上确实留了空间，长期看需要更清晰的解释性文件。', time: '5小时前', likes: 231, featured: false },
  { id: 903, topicId: 9, user: '周末看球', role: '网友', content: '官方这次公布裁判报告的速度比以往快，算是回应了大家最关心的部分。', time: '8小时前', likes: 96, featured: false },
  // topic 10
  { id: 1001, topicId: 10, user: '镜头语言课', role: '网友', content: '从机位数量看，如果是纯临场反应，很难在几秒内完成这么完整的切换。这不等于有剧本，但至少说明现场预案做得很足。', time: '2小时前', likes: 312, featured: true },
  { id: 1002, topicId: 10, user: '综艺小百科', role: '认证网友 · 节目策划', content: '现在综艺普遍采用「结构化真实」：给出情境和规则，反应交给嘉宾。讨论是不是剧本之前，先把这套机制说清楚会更公平。', time: '4小时前', likes: 268, featured: true },
  { id: 1003, topicId: 10, user: '边看边笑', role: '网友', content: '好看就够了，非要证明是不是剧本，其实观众也累。但导演说「没有剧本」这句话确实说满了。', time: '7小时前', likes: 145, featured: false },
  // topic 11
  { id: 1101, topicId: 11, user: '温柔的灯牌', role: '网友', content: '「私事不回应」其实是一个明确的边界声明。公众人物也有普通生活的权利，这一点应该被尊重。', time: '3小时前', likes: 366, featured: true },
  { id: 1102, topicId: 11, user: '隐私线研究员', role: '认证网友 · 媒体研究', content: '这类话题真正值得讨论的是：什么程度的关注是合理的，什么程度已经越过了边界。照片的来源往往比照片本身更重要。', time: '6小时前', likes: 294, featured: false },
  { id: 1103, topicId: 11, user: '路过打酱油', role: '网友', content: '希望大家讨论归讨论，别去翻别人同学、家人的账号，那是另一回事了。', time: '10小时前', likes: 402, featured: false },
  // topic 12
  { id: 1201, topicId: 12, user: '退款到账了', role: '网友', content: '我的退款两天就到账了，速度和流程都比预期顺利。召回批次也写得很清楚，这点要给分。', time: '4小时前', likes: 156, featured: true },
  { id: 1202, topicId: 12, user: '选品研究所', role: '认证网友 · 供应链', content: '第三方抽检报告还附了批次号，这种做法值得推广。直播带货最缺的就是可追溯的售后依据。', time: '8小时前', likes: 188, featured: false },
  { id: 1203, topicId: 12, user: '理性消费者', role: '网友', content: '关键还是把「抽检合格」和「没问题」区分开。报告只对送检批次负责，消费者要会看范围。', time: '12小时前', likes: 143, featured: false },
];

export const topicDetails: TopicDetail[] = [
  {
    topicId: 1,
    background:
      '一段时长不到一分钟的录制现场画面在社交平台流传，画面中出现了现场收音与走位调整。由于节目尚未播出，观众只能依据这段素材推测当时发生了什么，进而引发了关于「剪辑是否改变了事实」的大范围讨论。',
    focusPoints: [
      '外流素材属于粗剪还是成片，两者叙事差异有多大',
      '现场收音中的时间断点，是设备问题还是剪辑痕迹',
      '讨论应聚焦事件本身，还是聚焦素材为何外流',
    ],
    timeline: [
      { time: '昨日 21:10', text: '相关片段开始在社交平台流传，播放量快速上升' },
      { time: '昨日 23:40', text: '有后期从业者发布逐帧分析，指出两处时间断点' },
      { time: '今天 09:20', text: '节目官方账号更新了下期预告，未提及此事' },
      { time: '今天 14:20', text: '话题进入热榜前三，讨论区集中在「素材来源」上' },
    ],
    stances: [
      { party: '节目方', content: '截至目前未发布正式声明，仅在预告动态下回复「以正片为准」' },
      { party: '后期从业者', content: '认为该素材更接近粗剪版本，不建议用其推断节目最终叙事' },
      { party: '讨论区网友', content: '多数观点主张先查证素材来源，再讨论画面内容本身' },
    ],
    editorNote:
      '未播出的素材天然带有信息缺口，用它判断最终成片的态度，风险很高。比起追问「谁对谁错」，更值得追问的是素材如何流出的。',
  },
  {
    topicId: 2,
    background:
      '剧集开机前后，关于女主角是否换人的说法反复出现。剧组于凌晨发布长文说明，将变动解释为「角色调整源于剧本结构变化」，但没有给出具体的时间节点与人员安排，因此讨论仍在继续。',
    focusPoints: [
      '说明中「剧本结构变化」是否对应真实的制作流程',
      '已拍摄素材与已发布物料将如何处理',
      '官方为何选择凌晨发布而非正常工作时段',
    ],
    timeline: [
      { time: '开机前 3 天', text: '换角传闻首次出现在行业交流群，未获证实' },
      { time: '开机当天', text: '开机现场路透画面中未出现传闻中的演员' },
      { time: '今天 01:30', text: '剧组发布长文说明，解释为剧本结构变化' },
      { time: '今天 11:05', text: '话题登上热搜，讨论区对说明可信度出现两种判断' },
    ],
    stances: [
      { party: '剧组', content: '发布长文说明，称角色调整源于剧本结构变化，感谢观众理解' },
      { party: '编剧从业者', content: '认为此类调整在行业中确实存在，但通常伴随官宣节奏' },
      { party: '讨论区网友', content: '普遍希望得到更具体的时间安排与人员说明' },
    ],
    editorNote:
      '一份没有时间节点的说明，很难真正平息讨论。对于制作类传闻，' +
      '可验证的信息（开机、杀青、物料发布）比措辞更值得关注。',
  },
  {
    topicId: 3,
    background:
      '关于团体成员是否退团的讨论持续升温，多个粉丝后援会发布统一声明，希望经纪公司给出明确答复。截至目前，公司只更新了团体行程表，并未就传闻单独发文。',
    focusPoints: [
      '行程表的调整是否等同于对传闻的间接回应',
      '后援会统一声明的诉求是否具有可操作性',
      '合约类变动通常需要多久才能对外披露',
    ],
    timeline: [
      { time: '09-06', text: '成员缺席一场公开活动，退团传闻开始出现' },
      { time: '09-08', text: '多个后援会陆续发布统一声明，要求明确答复' },
      { time: '今天 09:48', text: '公司更新团体行程表，未就传闻单独发文' },
    ],
    stances: [
      { party: '经纪公司', content: '仅更新行程安排，暂未就退团传闻发布单独说明' },
      { party: '粉丝后援会', content: '发布统一声明，希望公司尽快给出明确、可核实的答复' },
      { party: '讨论区网友', content: '呼吁耐心等待官方口径，避免以行程变化过度推断' },
    ],
    editorNote: '用行程表回应传闻，是一种留白式沟通。它不否认也不承认，反而会让各种解释都找到空间。',
  },
  {
    topicId: 4,
    background:
      '有账号公开了一段后台花絮录音，录音中的人物与时间点成为争议核心。两个流传版本的时间线相差约四十分钟，讨论区正在核对当日公开行程与现场照片的拍摄时间。',
    focusPoints: [
      '两个版本的时间差，是否能用彩排时间解释',
      '录音的环境噪声是否连续，有无剪辑痕迹',
      '公开行程与现场照片能否交叉验证时间点',
    ],
    timeline: [
      { time: '昨日 18:00', text: '第一版录音在社交平台出现，标注时间点为傍晚' },
      { time: '昨日 20:30', text: '出现另一版本，标注时间比第一版晚约四十分钟' },
      { time: '昨日 22:31', text: '话题升温，讨论区开始整理当日公开行程' },
    ],
    stances: [
      { party: '发布账号', content: '称录音为其本人录制，未提供录制设备与元数据信息' },
      { party: '音频从业者', content: '指出环境噪声连续，但无法排除分段录制的可能' },
      { party: '讨论区网友', content: '主张先核对公开行程与现场照片的拍摄时间再下结论' },
    ],
    editorNote: '在没有元数据的情况下，录音的时间信息只能靠外部证据交叉验证。这正是讨论区最该做的事。',
  },
  {
    topicId: 5,
    background:
      '某品牌在多个平台临时下架了代言相关物料，官方客服回应为「档期调整」。由于同期没有公开的负面事件，讨论区对下架原因给出多种猜测，但都缺乏可靠信源。',
    focusPoints: [
      '「档期调整」在品牌运营中通常对应哪些情况',
      '线上与线下物料处理是否一致',
      '在缺乏信源时，讨论应如何保持边界',
    ],
    timeline: [
      { time: '昨日 14:00', text: '网友发现品牌线上物料被撤下，开始发帖询问' },
      { time: '昨日 16:30', text: '媒体向官方求证，客服回复「档期调整」' },
      { time: '昨日 19:12', text: '话题进入讨论区热榜，出现多种未证实猜测' },
    ],
    stances: [
      { party: '品牌方', content: '客服统一回复为「档期调整」，未提供更多细节' },
      { party: '品牌营销从业者', content: '认为物料下架存在多种常规原因，不能直接等同于负面事件' },
      { party: '讨论区网友', content: '多数观点认为目前证据不足，建议观望' },
    ],
    editorNote: '「没有坏消息」和「有好事发生」是两回事。在信息不足时，保持观望也是一种负责任的态度。',
  },
  {
    topicId: 6,
    background:
      '关于片场工作态度的说法每隔一段时间就会被提起。这一次有多位自称剧组工作人员陆续发文，内容彼此有重叠也有冲突，讨论区提醒先分辨信源再做判断。',
    focusPoints: [
      '不同工作人员的说法在哪些细节上存在冲突',
      '描述是否包含可核实的拍摄日期与场次',
      '作品评价与个人评价是否应该分开',
    ],
    timeline: [
      { time: '09-07', text: '第一篇自称剧组工作人员的长文出现' },
      { time: '09-08', text: '数位网友跟进发文，描述细节互有出入' },
      { time: '昨天 16:40', text: '话题升温，讨论区开始整理信源与时间对照表' },
    ],
    stances: [
      { party: '发文网友', content: '描述片场工作感受，部分内容包含具体日期，部分较为模糊' },
      { party: '剧组相关人士', content: '暂未就相关内容作出公开回应' },
      { party: '讨论区网友', content: '建议以可核实的细节为准，避免仅凭描述定性' },
    ],
    editorNote: '当多个说法互相矛盾时，最有用的做法不是选边，而是把可核实的部分单独列出来。',
  },
  {
    topicId: 7,
    background:
      '临开场前的阵容调整引发连锁反应，主办方称属于「不可抗力」，部分演出方则指向合同与结算问题。退票方案已经公布，但关于责任归属的讨论仍在继续。',
    focusPoints: ['不可抗力的具体所指是什么', '已购票观众的补偿方案是否完整', '后续如何避免同类临时调整'],
    timeline: [
      { time: '09-08 21:00', text: '主办方发布演出阵容调整公告' },
      { time: '09-09 09:00', text: '退票与改签通道开放' },
      { time: '昨天 12:03', text: '演出方发布说明，与主办方口径出现差异' },
    ],
    stances: [
      { party: '主办方', content: '公告称阵容调整属于不可抗力，已开放退票与改签' },
      { party: '部分演出方', content: '说明中提到合同与结算问题，与主办方口径存在差异' },
      { party: '讨论区网友', content: '更关心补偿方案与后续安排是否清晰' },
    ],
    editorNote: '观众最在意的从来不是谁先发声明，而是自己的票怎么退、什么时候到账。',
  },
  {
    topicId: 8,
    background:
      '一部播放量很高的短剧被指与更早发布的图文作品高度相似。原作者整理了从发布到改编的时间线，制作方回应「属于常见桥段」，双方尚未进入法律程序。',
    focusPoints: ['时间线能否支撑「在先发布」的结论', '「常见桥段」与「实质性相似」的界限', '取证方式对后续维权的影响'],
    timeline: [
      { time: '06-12', text: '原作者发布图文作品' },
      { time: '08-20', text: '短剧上线，播放量快速攀升' },
      { time: '09-08 21:15', text: '原作者整理时间线并公开发文' },
    ],
    stances: [
      { party: '原作者', content: '公开发布完整时间线，主张作品存在高度相似' },
      { party: '制作方', content: '回应称相关内容属于常见桥段，暂未进一步说明' },
      { party: '讨论区网友', content: '提醒区分「相似」与「抄袭」，关注具体表达是否重合' },
    ],
    editorNote: '梗概相似和表达相似是两件事。维权是否成立，取决于具体的表达比对，而不是整体观感。',
  },
  {
    topicId: 9,
    background:
      '一次关键判罚在赛后持续引发讨论。赛事官方公布了多个机位的回放与裁判报告，说明判罚依据，部分球迷认可解释，也有球迷认为规则本身需要进一步细化。',
    focusPoints: ['现行规则条文如何支撑这次判罚', '多角度回放是否消除了争议', '规则是否需要在下一赛季细化'],
    timeline: [
      { time: '09-07 21:30', text: '比赛出现关键判罚，赛后争议升温' },
      { time: '09-08 12:00', text: '赛事官方表示将公布多角度回放' },
      { time: '09-08 18:22', text: '官方公布回放与裁判报告，话题进入讨论区' },
    ],
    stances: [
      { party: '赛事官方', content: '公布多角度回放与裁判报告，说明判罚依据' },
      { party: '裁判从业者', content: '认为按现行条文判罚成立，但条文解释空间仍可优化' },
      { party: '讨论区球迷', content: '对解释存在两种看法，但普遍认可公开回放的做法' },
    ],
    editorNote: '争议从「判得对不对」转向「规则要不要改」，其实是讨论质量提升的表现。',
  },
  {
    topicId: 10,
    background:
      '一段临场救场的片段被反复传播，播放量迅速攀升。导演在采访中表示「没有剧本」，但网友从镜头切换与灯光调度上提出了不同看法，讨论集中在综艺的真实性边界。',
    focusPoints: ['镜头切换密度是否超出临场反应的可能', '「结构化真实」这一制作方式的边界', '观众期待的真实究竟指什么'],
    timeline: [
      { time: '09-07 黄金档', text: '节目播出，救场片段成为当期最高讨论点' },
      { time: '09-08 10:00', text: '片段剪辑版在社交平台传播，播放量破千万' },
      { time: '09-08 15:47', text: '导演受访回应「没有剧本」，网友提出新疑问' },
    ],
    stances: [
      { party: '节目导演', content: '受访表示现场没有剧本，嘉宾反应为真实呈现' },
      { party: '节目策划从业者', content: '介绍「结构化真实」的常见做法，认为需要更清晰的说明' },
      { party: '讨论区网友', content: '对真实性存在分歧，但普遍认可片段本身的观赏性' },
    ],
    editorNote: '综艺的真实从来不是「零设计」，而是设计到什么程度。把机制说清楚，比反复否认更有说服力。',
  },
  {
    topicId: 11,
    background:
      '几组生活照片在网络流传后，相关话题迅速升温。经纪公司简短回应「艺人私事不做回应」，讨论区随后转向「公众人物的隐私边界在哪里」这一更普遍的问题。',
    focusPoints: ['照片来源与传播链条是否合法', '公众人物的隐私边界如何界定', '粉丝与路人应如何讨论'],
    timeline: [
      { time: '09-06', text: '相关照片开始在私域流传' },
      { time: '09-07 20:10', text: '话题进入公开讨论区，经纪公司回应私事不回应' },
      { time: '09-08', text: '讨论重心从当事人转向隐私边界' },
    ],
    stances: [
      { party: '经纪公司', content: '简短回应，表示艺人私事不做回应' },
      { party: '媒体研究者', content: '指出讨论照片来源比讨论照片内容更值得关注' },
      { party: '讨论区网友', content: '多数观点呼吁尊重隐私，不扩散未经同意的个人信息' },
    ],
    editorNote: '当一个话题的热度建立在当事人的私人生活上时，降温本身就是一种态度。',
  },
  {
    topicId: 12,
    background:
      '关于某场直播货品质量的投诉集中出现后，平台公布了退款进度与第三方抽检结果。抽检显示部分批次需要召回，平台同时调整了该场次的售后通道。',
    focusPoints: ['抽检报告覆盖的批次范围', '退款进度与售后通道是否顺畅', '如何建立可追溯的售后依据'],
    timeline: [
      { time: '09-05', text: '关于货品质量的投诉集中出现' },
      { time: '09-06', text: '平台开通专项售后通道' },
      { time: '09-07 13:35', text: '第三方抽检结果与退款进度公布' },
    ],
    stances: [
      { party: '平台', content: '公布抽检结果与退款进度，开放专项售后通道' },
      { party: '供应链从业者', content: '认为附批次号的做法具备可追溯性，值得推广' },
      { party: '讨论区网友', content: '关注退款到账速度，提醒区分「抽检合格」与「全部合格」' },
    ],
    editorNote: '一份写明批次号的抽检报告，比一句「质量没问题」有用得多。',
  },
];